import { useRive, UseRiveParameters } from '@rive-app/react-webgl2';
import { useMemo } from 'react';
import cloudyBasicsRiv from '../assets/animations/cloudy_basics.riv?inline';

interface RiveCloudMascotProps {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
  stateMachine?: string;
  onStateChange?: (stateName: string) => void;
}

const riveOptions = {
  useDevicePixelRatio: true,
  shouldResizeCanvasToContainer: true,
}

export default function RiveCloudMascot({
  size,
  className,
  style,
  onStateChange,
}: RiveCloudMascotProps) {

  const riveConfig: UseRiveParameters = useMemo(() => ({
    src: cloudyBasicsRiv,
    stateMachines: 'Basics',
    autoplay: true,
    onStateChange: (event) => {
      const states = event.data as string[];
      if (states?.length) {
        onStateChange?.(states[0]);
      }
    }
  }), [onStateChange]);

  const { RiveComponent } = useRive(
    riveConfig,
    riveOptions
  );

  const containerStyle: React.CSSProperties = useMemo(() => ({
    ...(size ? { width: size, height: size } : {}),
    ...style,
  }), [size, style])

  return (
    <div className={className} style={containerStyle}>
      <RiveComponent />
    </div>
  );
}
